import API from '@/api';
// const Pms = API.get('Pms');
const PmsV2 = API.get('PmsV2');

export default ({
  namespaced: true,

  state: {
    patients: [],
    patient: null
  },

  getters: {
    patients: state => state.patients,
    patient: state => state.patient
  },

  mutations: {
    setPatients(state, patients) {
      console.log({ state, patients }, "setPatients")
      state.patients = patients
    },
    setPatient(state, patient) {
      state.patient = patient
    },
    clearData(state) {
      state.patients = []
      state.patient = null
    }
  },

  actions: {
    async fetchPatients(state, {caseNumber='', patientIdNumber=''}) {
      //Test patient ID 000001338CRM
      // Test CaseID CAS-157107-M5F6J2 ; CAS-126692-P2M7F0

      if (patientIdNumber) {
        let params = {
          patient_id: patientIdNumber
        }
  
        let response = await PmsV2.getCases(params);

        let patient = await PmsV2.getPatientInformation(params);

        console.log({ response, patient }, "INFO")

        let formattedResponses = response.data.map(item => {
          return {
            CaseNumber: item.CaseNumber,
            PatientDetails: {
              ...patient.data.ResponseBody,
              Height: patient.data.ResponseBody.Height.replace(/[^0-9.]/g,''), //height in cm
              Weight: patient.data.ResponseBody.Weight.replace(/[^0-9.]/g,'') //weight in kg
            }
          }
        });

        console.log({ formattedResponses });

        await state.commit('setPatients', formattedResponses);

        return;
      }
      
      if (caseNumber) {
        let params = {
          case_id: caseNumber
        };
  
        let response = await PmsV2.findCase(params);
        
        let patientId = response.data.ResponseBody?.PatientDetails?.PatientId;
        
        let patient = await PmsV2.getPatientInformation({
          patient_id: patientId
        });

        console.log({ response, patient }, "INFO")


        let formattedResponses = [
          {
            CaseNumber: response.data.ResponseBody.CaseNumber,
            CaseTitle: response.data.ResponseBody.CaseTitle,
            PatientDetails: {
              ...patient.data.ResponseBody,
              Height: patient.data.ResponseBody.Height.replace(/[^0-9.]/g,''), //height in cm
              Weight: patient.data.ResponseBody.Weight.replace(/[^0-9.]/g,'') //weight in kg
            }
          }
        ];

        console.log({ formattedResponses });
  
        await state.commit('setPatients', formattedResponses);

        return;
      }

      await state.commit('setPatients', []);
    },
  }
})